module.exports = __webpack_public_path__ + "static/media/consume-https-resources.94570c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/consume-https-resources.svg
// module id = 112
// module chunks = 0